import styled from "styled-components";

const Label = styled.label`
  align-self: center;
`;

export default Label;
